import {
  debugConversion,
  formatApiRequest,
  toCamelCase,
  toSnakeCase,
  toUrlParams,
} from './conversion/format';
import {
  createPaginatedRequest,
  extractApiData,
  handleApiResponse,
  handlePaginatedApiResponse,
  isErrorResponse,
  isSuccessResponse,
  parseApiResponse,
  parsePaginatedResponse,
} from './conversion/response';

export * from './conversion/format';
export * from './conversion/response';

const conversion = {
  toSnakeCase,
  toCamelCase,
  formatApiRequest,
  parseApiResponse,
  parsePaginatedResponse,
  toUrlParams,
  isSuccessResponse,
  isErrorResponse,
  extractApiData,
  createPaginatedRequest,
  handleApiResponse,
  handlePaginatedApiResponse,
  debugConversion,
};

export default conversion;
